import { useState } from 'react';

function NumeralRow({ label, value, onChange, unit = 'MT' }) {
  return (
    <div
      className='d-flex align-items-center border rounded bg-white'
      style={{ height: 36 }}
    >
      <span className='small text-muted ps-2 pe-1'>{label}</span>
      <input
        type='number'
        step='0.001'
        value={value}
        onChange={e =>
          onChange(e.target.value === '' ? '' : Number(e.target.value))
        }
        className='form-control border-0 bg-transparent shadow-none px-1'
        style={{
          minWidth: 0,
          flex: '1 1 0%',
          height: '100%',
          MozAppearance: 'textfield',
          WebkitAppearance: 'textfield',
        }}
      />
      <span className='small text-muted pe-2 ps-1 flex-shrink-0'>{unit}</span>
    </div>
  );
}

function RefrigeratedGroup({ title, data, onChange }) {
  return (
    <div className='border rounded p-3 bg-white'>
      <div className='small fw-semibold text-dark mb-3'>{title}</div>
      <div className='d-flex gap-3'>
        <div className='flex-fill'>
          <NumeralRow
            label='Min'
            value={data.min}
            onChange={v => onChange({ ...data, min: v })}
          />
        </div>
        <div className='flex-fill'>
          <NumeralRow
            label='Max'
            value={data.max}
            onChange={v => onChange({ ...data, max: v })}
          />
        </div>
      </div>
    </div>
  );
}

export default function Composition({ form, setForm, comptitle }) {
  const [compositionError, setCompositionError] = useState(null);

  const butaneData = {
    min: form.compositionMin ?? '',
    max: form.compositionMax ?? '',
  };

  const handleButaneChange = data => {
    const min = data.min === '' || data.min == null ? null : Number(data.min);
    const max = data.max === '' || data.max == null ? null : Number(data.max);

    if (min != null && max != null && min > max) {
      setCompositionError('Min cannot be greater than Max');
    } else {
      setCompositionError(null);
    }

    setForm(prev => ({
      ...prev,
      compositionMin: data.min === '' ? null : data.min,
      compositionMax: data.max === '' ? null : data.max,
    }));
  };

  return (
    <div className='mb-3'>
      <RefrigeratedGroup
        title={comptitle}
        data={butaneData}
        onChange={handleButaneChange}
      />
      {compositionError && (
        <div className='text-danger d-flex align-items-center gap-1 mt-1'>
          <i className='mdi mdi-alert-circle-outline'></i>
          <span>{compositionError}</span>
        </div>
      )}
    </div>
  );
}
